<i18n src="@/locales/models/quality_inspect.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/agro_exporter/quality_control/container/list_export_quality_inspects.yml"
  lang="yaml"
></i18n>

<template>
  <div class="mt-8 flex flex-col">
    <div class="table-first-container">
      <div class="table-second-container">
        <div class="table-third-container">
          <table class="table">
            <thead class="table-header">
              <tr>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.quality_inspect.week") }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.quality_inspect.registered_at") }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.quality_inspect.inspect_code") }}
                </th>
                <!-- <th scope="col" class="table-header-cell"> -->
                <!--   {{ $t("model.quality_inspect.provider") }} -->
                <!-- </th> -->
                <th scope="col" class="table-header-cell" v-if="show_samplings">
                  {{ $t("model.quality_inspect.samplings") }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.quality_inspect.quality_accepted_percent") }}
                </th>
                <th
                  scope="col"
                  class="table-header-cell"
                  v-for="quality_template_gui in quality_template.quality_template_guis"
                  :key="quality_template_gui.quality_attribute.id"
                >
                  {{
                    quality_template_gui.quality_attribute.crop_attribute.name
                  }}
                </th>
                <th scope="col" class="table-header-cell"></th>
              </tr>
            </thead>
            <tbody class="table-body">
              <tr
                class="table-row"
                v-for="quality_inspect in quality_inspects"
                :key="quality_inspect.id"
              >
                <td class="table-cell-pos">
                  {{ quality_inspect.week }}
                </td>
                <td class="table-cell-main cursor-pointer">
                  {{ dateFormatterDayMonthName(quality_inspect.registered_at) }}
                </td>
                <td class="table-cell-main cursor-pointer">
                  {{ quality_inspect.inspect_code }}
                </td>
                <!-- <td class="table-cell"> -->
                <!--   {{ -->
                <!--     producerOrOrganizationLabel(quality_inspect.exported_batch) -->
                <!--   }} -->
                <!-- </td> -->
                <td class="table-cell" v-if="show_samplings">
                  {{ quality_inspect.samplings }}
                </td>
                <td class="table-cell">
                  {{ quality_inspect.quality_accepted_percent }}%
                </td>
                <td
                  class="table-cell"
                  v-for="quality_template_gui in quality_template.quality_template_guis"
                  :key="quality_template_gui.quality_attribute.id"
                >
                  {{
                    qualityGeneralValueByInspectGUI(quality_inspect, quality_template_gui)
                  }}
                </td>

                <td class="table-cell-action">
                  <a
                    class="link flex"
                    @click.prevent="goToShow(quality_inspect)"
                  >
                    <i class="fa-solid fa-pen"></i>
                    <span class="space-icon"></span
                    >{{ $t("labels.manage_link") }}
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QualityTemplateGUIMixin from '@/components/views/layout/quality_control/mixins/quality_template_gui.js';

export default {
  name: "InspectionDetails",
  mixins: [QualityTemplateGUIMixin],
  data() {
    return {};
  },
  props: {
    quality_template: {
      required: true,
    },
    quality_inspects: {
      required: true,
    },
    goToShow: {
      type: Function,
      required: true,
    },
  },
  computed: {
    show_samplings: function () {
      if (this.quality_template)
        return (
          this.quality_template.use_samplings &&
          !this.quality_template.specific_sampling
        );
      return false;
    },
  },
  methods: {
    producerOrOrganizationLabel: function (exported_batch) {
      if (!exported_batch) return;
      let label = "";
      if (exported_batch.producer) label += exported_batch.producer.name;
      if (exported_batch.organization) {
        if (label) label += ` (${exported_batch.organization.name})`;
        else label += exported_batch.organization.name;
      }
      return label;
    },
  },
};
</script>
